import { InvoiceStatusFilter } from './invoice-status-filter';
import { InvoiceDueDateFilter } from './invoice-due-date-filter';
import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { createdAtFilterConfig } from '../../../configs/created-at-filter-config';
import { labelFilterConfig } from '../../../configs/label-filter-config';

export function InvoiceFilters() {
  return (
    <div className='flex flex-col gap-4'>
      <InvoiceStatusFilter />
      <InvoiceDueDateFilter />
      <InputFilterTrigger
        filterLabel='Created At'
        config={createdAtFilterConfig}
      />
      <InputFilterTrigger
        filterLabel='Labels'
        config={labelFilterConfig}
      />
    </div>
  );
}
